<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
        marginBottom: '20px',
        paddingBottom: '20px',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>alarm</v-icon>
          </div>
          <h1 style="display: inline">
            Reporte de asistencia de colaboradores
          </h1>
        </v-flex>
        <router-link :to="{ name: 'Reports' }">
          <v-icon>close</v-icon>
        </router-link>
      </v-layout>
      <v-speed-dial
        absolute
        bottom
        left
        direction="bottom"
        open-on-hover
        transition="scale-transition"
        style="bottom: 0"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="gradiente" dark fab>
            <v-icon>more_vert</v-icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadPDF(filters)"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
          <span>Descargar PDF</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadXLSX(filters)"
          >
            <v-img
              :style="{ flex: '0 1 auto' }"
              height="28px"
              width="28px"
              :src="require('@/assets/reports/IconoCSV.png')"
            />
          </v-btn>
          <span>Descargar XLSX</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadXlsModal"
          >
            <v-icon>sim_card_download</v-icon>
          </v-btn>
          <span>Exportar XLSX por fechas</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="showSettingModal"
          >
            <v-icon>settings</v-icon>
          </v-btn>
          <span>Ajuste de reportes</span>
        </v-tooltip>
      </v-speed-dial>
    </v-toolbar>
    <AttendanceTardies
      @updateFilters="
        (f) => {
          filters = f
        }
      "
    />
    <ReportSettings
      :show="showSetting"
      title="Configuración de horario de colaboradores"
      reportSettingtype="COLLABORATOR_ASSISTANCE"
      @closeEditSetting="onCloseEditSetting"
    />
    <loading v-model="toast.loading" text="Trabajando"></loading>
    <success v-model="toast.success" text="Operación Exitosa"></success>
    <error v-model="toast.error" text="Ups ocurrió un error"></error>
    <DowloadXlsModal
      :isOpen="modalXls"
      :startDate="today"
      @onClose="modalXls = !modalXls"
      @onGetReport="downloadXlsReport"
      ref="dowloadXlsModalChecker"
    />
  </div>
</template>

<script>
import moment from 'moment'
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import DowloadXlsModal from '../../Modals/DownloadXlsModal.vue'
import ReportSettings from '../../Modals/reportSettings/reportSettingsCustomCollaborator.vue'
import AttendanceTardies from '../../Sections/Checker/AttendanceTardies.vue'

export default {
  components: {
    DowloadXlsModal,
    AttendanceTardies,
    ReportSettings,
    error,
    loading,
    success,
  },
  data: () => ({
    today: moment().format('YYYY-MM-DD'),
    modalXls: false,
    toast: {
      loading: false,
      success: false,
      error: false,
    },
    filters: {},
    showSetting: false,
  }),
  methods: {
    showSettingModal() {
      this.showSetting = true
    },
    onCloseEditSetting() {
      this.showSetting = false
    },
    downloadPDF(filters) {
      this.toast.loading = true
      const newFilters = {}
      for (const property in filters) {
        const value = filters[property]
        if (value) {
          newFilters[property] = value
        }
      }
      this.$store
        .dispatch('checker/downloadReportPDF', newFilters)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'reporte-horarios-colaboradores.pdf'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.toast.success = true
        })
        .catch((e) => {
          console.error(e)
          this.toast.error = true
        })
        .finally(() => (this.toast.loading = false))
    },
    downloadXLSX(filters, isModalXlsxDate = false, xlsxDates) {
      this.toast.loading = true
      let newFilters = {}
      for (const property in filters) {
        const value = filters[property]
        if (value) {
          newFilters[property] = value
        }
      }

      if (isModalXlsxDate === true) {
        newFilters = {
          ...newFilters,
          ...xlsxDates,
        }
      }

      this.$store
        .dispatch('checker/downloadReportXLSX', newFilters)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'reporte-horarios-colaboradores.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.toast.success = true
        })
        .catch((e) => {
          console.error(e)
          this.toast.error = true
        })
        .finally(() => (this.toast.loading = false))
    },
    downloadXlsModal() {
      this.$refs.dowloadXlsModalChecker.onOpen()
      this.modalXls = true
    },
    downloadXlsReport(e) {
      this.downloadXLSX(this.filters, true, {
        from: e.startDate,
        to: e.endDate,
      })
      this.$refs.dowloadXlsModalChecker.onClose()
      this.modalXls = false
    },
  },
}
</script>
